import "./styles.scss";

import React, { useRef } from "react";
import { Link } from "gatsby";
import {
  motion,
  useMotionTemplate,
  useScroll,
  useTransform,
} from "framer-motion";
import { useMediaQuery } from "react-responsive";

import { useHamburger } from "context/hamburger";

import AnimatedGradient from "components/AnimatedGradient";

const Hero = ({ clinic, title, caption }) => {
  const { setIsContactOpen, setIsCompactContactOpen } = useHamburger();

  const ref = useRef(null);

  const { scrollYProgress: progress } = useScroll({
    target: ref,
    offset: ["start", "end start"],
  });

  const ball_y_1 = useTransform(progress, [0, 1], [0, -125]);
  const ball_y_2 = useTransform(progress, [0, 1], [0, -75]);
  const ball_y_3 = useTransform(progress, [0, 1], [0, -50]);
  const ball_transform_template = [
    useMotionTemplate`translate(0, ${ball_y_1}%)`,
    useMotionTemplate`translate(0, ${ball_y_2}%)`,
    useMotionTemplate`translate(0, ${ball_y_3}%)`,
  ];

  const isBrowser = typeof window !== "undefined";
  const isMobile = useMediaQuery({
    query: "(max-width: 991px)",
  });

  const ballsData = [
    {
      label: "Zadzwoń",
      onClick: isBrowser
        ? isMobile
          ? () => setIsCompactContactOpen(true)
          : () => setIsContactOpen(true)
        : undefined,
    },
    {
      label: "Umów wizytę",
      url: "/rezerwacja-wizyt/",
    },
    {
      label: "Wyślij wiadomość",
      url: "/kontakt/",
    },
  ];

  return (
    <section className="main-hero" ref={ref}>
      <div className="main-hero__content">
        <div className="container">
          <div className="main-hero__content-wrapper">
            <div className="main-hero__content-wrapper-inner">
              {clinic && <h1>{clinic}</h1>}
              {title && <h2>{title}</h2>}
            </div>
            <div className="main-hero__balls">
              {ballsData.map((ball, index) => {
                const isButton = typeof ball?.onClick === "function";
                const isLink = ball?.url;
                const Type = isButton ? "button" : isLink ? Link : "div";

                return (
                  <motion.div
                    key={index}
                    className={`main-hero__balls-item main-hero__balls-item--${
                      index + 1
                    }`}
                    style={{
                      transform: ball_transform_template[index],
                    }}
                  >
                    <Type
                      type={isButton ? "button" : undefined}
                      to={isLink ? ball.url : undefined}
                      onClick={isButton ? ball.onClick : undefined}
                    >
                      {ball.label}
                    </Type>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="main-hero__mask" />
      </div>
      {caption && (
        <div className="main-hero__caption">
          <div
            className="container"
            dangerouslySetInnerHTML={{ __html: caption }}
          />
        </div>
      )}
      <AnimatedGradient id="hero-gradient" />
    </section>
  );
};

export default Hero;
